module.exports = __webpack_public_path__ + "static/media/blogdemystif.d8c348c7.jpg";